import React, { useEffect, useRef, useState } from "react";
import Layout from '../../../components/layout';
import Header from '../../../components/header';
import Button from '../../../components/elements/button';
import BillComMDModalWrapper from "./BillComMDModalWrapper";
import { useBillComApi } from '../../../store/api/hooks/billComApiHook';
import toast from 'react-hot-toast';
import { useAppLoader } from '../../../_common/pageLoader/appLoaderHook';
import { showLocalDateTime } from '../../../_common/functions';

const syncItems = [
    { label: 'Sync Vendor', itm: 'syncVendor' },
    { label: 'Sync Department', itm: 'syncDepartment' },
];

const BillComMasterDataSync: React.FC = () => {
    const billComApi: any = useBillComApi();
    const BillComMDNewModalRef = useRef<any>(null);
    const { showLoader, hideLoader } = useAppLoader();

    const [vrowData, setvrowData] = useState<any>(null);
    const [deptrowData, setDeptrowData] = useState<any>(null);
    const [selectedItem, setSelectedItem] = useState<string | null>(null);

    const handleSync = (itm: string) => {
        showLoader();
        const payload = {};

        const callback = (setter: any) => (resp: any) => {
            if (resp.successful) {
                setter(resp);
                toast.success(resp?.message);
            } else {
                toast.error(resp.message || "Connection Failed");
            }
            hideLoader();
        };

        const errorHandler = (error: any) => {
            toast.error(error);
            hideLoader();
        };

        if (itm === 'syncVendor') {
            setvrowData(null);
            billComApi.syncVendor(payload, callback(setvrowData), errorHandler);
        } else if (itm === 'syncDepartment') {
            setDeptrowData(null);
            billComApi.syncDepartment(payload, callback(setDeptrowData), errorHandler);
        }
    };

    const renderSyncInfo = (itm: string) => {
        const dataMap: any = {
            syncVendor: vrowData,
            syncDepartment: deptrowData,
        };

        const data = dataMap[itm];
        if (!data) return null;

        return (
            <div className="text-sm text-gray-600">
                {data?.totalRecord && (
                    <div className="font-medium text-green-600">
                        {data.totalRecord} Records Synced Successfully
                    </div>
                )}
                {data?.data?.lastSyncDate && (
                    <div className="mt-1">
                        Last Sync: <span className="font-medium">{showLocalDateTime(data.data.lastSyncDate)}</span>
                    </div>
                )}
                {data?.message && (
                    <div className="mt-1 text-blue-600">
                        {data.message}
                    </div>
                )}
            </div>
        );
    };


    const openLogModal = (itm: string) => {
        setSelectedItem(itm);
        BillComMDNewModalRef.current?.show();
    };

    useEffect(() => {
        //GetDefaultDataSync();
        handleSync('syncVendor');
        handleSync('syncDepartment');
    }, []);

    return (
        <Layout>
            <Header title="Bill.com Master Data Sync" back="/settings" />

            <div className="container mx-auto mt-6 px-4">
                <div className="bg-white shadow rounded-md overflow-hidden">
                    <div className="p-5 border-b">
                        <h2 className="text-lg font-semibold text-gray-800">Sync Bill.com Master Data</h2>
                    </div>

                    {syncItems.map((item, index) => (
                        <div
                            key={index}
                            className="grid md:grid-cols-5 gap-4 border-t p-5 items-start"
                        >
                            <div className="text-gray-600 font-medium">
                                {item.label}
                                {item.itm === 'syncSCVendor' && (
                                    <div className="text-xs text-blue-600 mt-1">Special Connector Vendor</div>
                                )}
                            </div>

                            <div>
                                <Button
                                    type="button"
                                    className="w-full bg-success text-white flex items-center justify-center"
                                    onClick={() => handleSync(item.itm)}
                                >
                                    Click Here
                                </Button>
                            </div>

                            <div className="md:col-span-2">{renderSyncInfo(item.itm)}</div>

                            <div className="text-right">
                                <Button
                                    type="button"
                                    theme="secondary"
                                    onClick={() => openLogModal(item.itm)}
                                >
                                    Show Log
                                </Button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Modal rendered once */}
            <BillComMDModalWrapper ref={BillComMDNewModalRef} item={selectedItem} />
        </Layout>
    );
};

export default BillComMasterDataSync;